<div [@routerTransition]>
    <sub-header [title]="('ViewStockReceive' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="form-group m-form__group">
                            <label for="PaymentTermName">{{ l('FromLocation') }}</label>
                           <input type="text"  class="form-control" disabled="disabled" [(ngModel)]="this.fromLocation"/>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="stockTransfer_PDate">{{ l('PDate') }}</label>

                            <abp-datetime-picker #stockTransfer_date="ngModel" [(ngModel)]="stockTransfer.transferDate"
                                                 id="stockTransfer_date" name="stockTransfer_transferDate"
                                                 [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>

                            <validation-messages [formCtrl]="stockTransfer_date"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="stockTransfer_Remarks">{{ l('Remarks') }}</label>
                            <input type="text"
                                   id="stockTransfer_Remarks" class="form-control"
                                   [(ngModel)]="stockTransfer.remarks" name="Remarks" />
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div  class="col-md-12" style="text-align:right; margin-bottom:5px;">
                        <button (click)="receiveAll()"
                                class="btn btn-primary blue float-right" [buttonBusy]="saving"
                                [busyText]="l('SavingWithThreeDot')">
                            <i class="fa fa-save"></i>
                            <span>{{ l('ReceiveAll') }} </span>
                        </button>
                    </div>
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th width="10%">{{ l('ItemCode') }}</th>
                                    <th width="30%">{{ l('ItemName') }}</th>
                                    <th width="8%">{{ l('IssuedQty') }}</th>
                                    <th width="8%">{{ l('ReceivedQty') }}</th>
                                    <th width="8%">{{ l('ReceiveQty') }}</th>
                                    <th width="8%">{{ l('Diff') }}</th>
                                    <th width="8%" class="text-center">{{ l('UOM') }}</th>
                                    <th width="8%" class="text-center">{{ l('Cost') }}</th>
                                    <th width="8%">{{ l('TotalCost') }}</th>
                                    <th width="5%">{{ l('Action') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of stockTransferDetails; let i = index">
                                    <td class="align-middle">
                                        <b>{{data.productCode}}</b>
                                    </td>
                                    <td class="align-middle">
                                        <b>{{data.productName}}</b>
                                    </td>
                                    <td><input type="text" #qtyInput (keydown.enter)="focusNext('cost', i)" disabled="disabled" class="form-control text-end" appAllowDecimal [(ngModel)]="data.qty" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td><input type="text" #qtyInput (keydown.enter)="focusNext('cost', i)" disabled="disabled" class="form-control text-end" appAllowDecimal [(ngModel)]="data.receivedQty" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td><input type="text" #qtyInput (keydown.enter)="focusNext('cost', i)" class="form-control text-end" appAllowDecimal [(ngModel)]="data.qtyToReceive" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td class="align-middle text-end"><b>{{data.diffQty}}</b></td>
                                    <td class="align-middle text-center">
                                        <a *ngIf="!data.changeUnitFlag" (click)="changeUnit(data)"><span><b> {{data.unitName}} </b> </span> </a>
                                        <a href="#"> {{data.UnitName}} </a>
                                    </td>
                                    <td><input type="text" #costInput (keydown.enter)="focusNext('focQty', i)" disabled="disabled" class="form-control text-end" appAllowDecimal [(ngModel)]="data.cost" (ngModelChange)="amountCalculate(data)" /></td>
                                    <td class="align-middle text-end"><b>{{data.totalCost }}</b></td>
                                    <td width="5%" class="text-center">
                                        <input type="button" [disabled]="data.buttonLabel == 'Returned'" *ngIf="data.diffQty != 0" class="btn btn-danger" value="{{data.buttonLabel}}" (click)="returnStockTransfer(data)" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table>
                            <tr>
                                <td width="80%" style="vertical-align: top">
                                    <div class="row" style="margin-right:8px;">
                                        <div class="col-md-8">&nbsp;&nbsp;</div>
                                        
                                    </div>
                                </td>
                                <td width="20%" style="vertical-align: top">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="stockTransfer_PSubTotal">{{ l('TotalQty') }}</label>
                                                <input type="number" readonly="readonly"
                                                       id="stockTransfer_PSubTotal" class="form-control text-end"
                                                       [(ngModel)]="stockTransfer.transferQty" name="PSubTotal" />

                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="stockTransfer_PSubTotal">{{ l('ReceivedQty') }}</label>
                                                <input type="number" readonly="readonly"
                                                       id="stockTransfer_PSubTotal" class="form-control text-end"
                                                       [(ngModel)]="receivedQty" name="PSubTotal" />

                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="stockTransfer_PGrandTotal">{{ l('TotalCost') }}</label>
                                                <input type="number"
                                                       id="stockTransfer_PGrandTotal" class="form-control text-end"
                                                       [(ngModel)]="stockTransfer.transferTotal" name="PGrandTotal" readonly="readonly" />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="stockTransfer_PNetTotal">{{ l('TotalPrice') }}</label>
                                                <input type="number"
                                                       id="stockTransfer_PNetTotal" class="form-control text-end"
                                                       [(ngModel)]="stockTransfer.transferTotalPrice" name="PNetTotal" readonly="readonly" />

                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save()"
                            class="btn btn-primary blue float-right" [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }} </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
